import { ReactElement } from 'react';

import { ObjectValues } from 'helpers/types';

export type IconMap = {
  [key: string]: ReactElement;
};

export const ONE_PAGE_SECTION_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TRANSPARENT: 'transparent',
} as const;

export type ISectionVariant = ObjectValues<typeof ONE_PAGE_SECTION_VARIANTS>;

export interface ISectionContainerProps {
  title: string;
  content: string;
  className?: string;
  icon?: ReactElement;
  variant?: ISectionVariant;
  customStyles?: any;
}
